/* Responsive read-only history dialog; no restore/edit actions. */
(function () {
  'use strict';
  var api = window.ARTICLE_REVISIONS;
  var current;
  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function button(label, handler, cls) {
    var node = el('button', cls, label);
    node.type = 'button'; node.addEventListener('click', handler);
    return node;
  }
  function shortDate(ts) {
    return new Date(ts * 1000).toLocaleString(api.language(), {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false
    });
  }
  function close() {
    if (!current) return;
    var state = current; current = null;
    state.controller.abort(); state.dialog.close(); state.dialog.remove();
    document.body.classList.remove('revision-history-open');
    var target = state.opener;
    if (!target || !target.getClientRects().length) target = state.article.querySelector('.zaglavie-more-btn');
    if (!target || !target.getClientRects().length) target = state.article.querySelector('.zaglavie');
    if (target && target.isConnected) target.focus();
  }
  function tabs(state, side) {
    state.side = side;
    var mobile = matchMedia('(max-width: 767px)').matches;
    ['before', 'after'].forEach(function (name) {
      state[name + 'Tab'].setAttribute('aria-selected', String(side === name));
      state[name + 'Tab'].tabIndex = side === name ? 0 : -1;
      state[name + 'Pane'].hidden = mobile && side !== name;
    });
    requestAnimationFrame(function () {
      if (current !== state) return;
      ['before', 'after'].forEach(function (name) {
        var pane = state[name + 'Pane'];
        if (pane.hidden || state.firstChangeShown[name]) return;
        var mark = pane.querySelector('del.diff-del, ins.diff-ins');
        if (mark) pane.scrollTop += mark.getBoundingClientRect().top - pane.getBoundingClientRect().top - 24;
        state.firstChangeShown[name] = true;
      });
    });
  }
  function status(state, key) {
    state.status.textContent = api.text(key); state.status.hidden = false;
    state.retry.hidden = key !== 'error'; state.content.hidden = true;
    state.meta.hidden = true;
  }
  function navigation(state) {
    state.nav.hidden = !state.items.length;
    state.older.disabled = state.busy || (state.index + 1 >= state.items.length && !state.next);
    state.newer.disabled = state.busy || state.index <= 0;
    state.select.disabled = state.busy || !state.items.length;
  }
  function options(state) {
    state.select.replaceChildren();
    state.items.forEach(function (item, i) {
      var option = el('option', '', shortDate(item.published_at));
      option.value = String(i); state.select.appendChild(option);
    });
    state.select.value = String(state.index);
  }
  function formattingBreaks(before, after) {
    function breaks(body) {
      var walker = document.createTreeWalker(body, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
      var offset = 0, found = [], node;
      while ((node = walker.nextNode())) {
        if (node.nodeType === Node.TEXT_NODE) offset += node.textContent.length;
        else if (/^(D-SEP|BR|B-R)$/.test(node.tagName)) found.push({ node: node, key: node.tagName + ':' + offset });
      }
      return found;
    }
    var oldBreaks = breaks(before), newBreaks = breaks(after);
    function mark(changes, opposite, tag, cls) {
      var counts = new Map();
      opposite.forEach(function (item) { counts.set(item.key, (counts.get(item.key) || 0) + 1); });
      changes.forEach(function (item) {
        if (counts.get(item.key)) { counts.set(item.key, counts.get(item.key) - 1); return; }
        var marker = el(tag, cls + ' revision-break-marker', '¶');
        marker.title = api.text('paragraph_break'); marker.setAttribute('aria-label', marker.title);
        item.node.before(marker);
      });
    }
    mark(oldBreaks, newBreaks, 'del', 'diff-del');
    mark(newBreaks, oldBreaks, 'ins', 'diff-ins');
  }
  async function showRevision(state) {
    var item = state.items[state.index];
    if (!item) { status(state, 'empty'); navigation(state); return; }
    state.busy = true; navigation(state); status(state, 'loading');
    try {
      var data = await api.request({ guid: state.guid, revision: item.id }, state.controller.signal);
      if (current !== state) return;
      state.select.value = String(state.index);
      state.meta.textContent = (data.author || api.text('author'))
        + ' · ' + api.text(data.kind === 'retire' ? 'retire' : data.kind === 'restore' ? 'restore' : 'content');
      state.meta.hidden = false;
      // Server sanitized both historical sides and generates only word diff wrappers.
      state.beforeBody.innerHTML = data.diff.before;
      state.afterBody.innerHTML = data.diff.after;
      var formattingOnly = data.diff.changed && data.diff.highlighted
        && (state.beforeBody.textContent === state.afterBody.textContent
          || (!state.beforeBody.querySelector('del.diff-del') && !state.afterBody.querySelector('ins.diff-ins')));
      if (formattingOnly) {
        [state.beforeBody, state.afterBody].forEach(function (body) {
          body.querySelectorAll('del.diff-del, ins.diff-ins').forEach(function (mark) { mark.replaceWith(...mark.childNodes); });
        });
        formattingBreaks(state.beforeBody, state.afterBody);
      }
      var removed = state.beforeBody.querySelectorAll('del.diff-del').length;
      var added = state.afterBody.querySelectorAll('ins.diff-ins').length;
      state.beforeTab.textContent = api.text('before') + (removed ? ' · −' + removed : '');
      state.afterTab.textContent = api.text('after') + (added ? ' · +' + added : '');
      var oldNote = state.beforePane.querySelector('.revision-empty-version');
      if (oldNote) oldNote.remove();
      if (!state.beforeBody.textContent.trim() && !state.beforeBody.querySelector('img'))
        state.beforeBody.before(el('p', 'revision-empty-version', api.text('no_previous')));
      state.beforePane.scrollTop = state.afterPane.scrollTop = 0;
      state.firstChangeShown = {};
      state.notice.textContent = formattingOnly ? api.text('formatting_only') : !data.diff.changed ? api.text('unchanged')
        : !data.diff.highlighted ? api.text('large') : '';
      state.notice.hidden = !state.notice.textContent;
      state.status.hidden = true; state.retry.hidden = true; state.content.hidden = false;
      // A deletion-only edit must be visible immediately on a phone.
      tabs(state, removed && !added ? 'before' : 'after');
    } catch (e) { if (current === state) status(state, 'error'); }
    finally { if (current === state) { state.busy = false; navigation(state); } }
  }
  async function load(state, earlier) {
    state.retryEarlier = earlier;
    state.busy = true; navigation(state); status(state, 'loading');
    try {
      var params = { guid: state.guid };
      if (earlier) params.before = state.next;
      var data = await api.request(params, state.controller.signal);
      if (current !== state) return;
      var previousLength = state.items.length;
      state.items = earlier ? state.items.concat(data.history) : data.history;
      state.next = data.next;
      if (earlier && state.items.length > previousLength) state.index = previousLength;
      options(state); await showRevision(state);
      state.retryEarlier = false;
    } catch (e) { if (current === state) status(state, 'error'); }
    finally { if (current === state) { state.busy = false; navigation(state); } }
  }
  api.open = function (article, opener) {
    close();
    var guid = article.getAttribute('data-guid');
    if (!guid) return;
    var state = current = { article: article, opener: opener, guid: guid,
      items: [], index: 0, next: null, side: 'after', firstChangeShown: {}, busy: false, controller: new AbortController() };
    var dialog = state.dialog = el('dialog', 'revision-dialog');
    dialog.setAttribute('aria-labelledby', 'revision-history-heading');
    var header = el('header', 'revision-header');
    var heading = el('div', 'revision-heading');
    var title = el('p', 'revision-caption', api.text('title')); title.id = 'revision-history-heading';
    heading.appendChild(title);
    var term = el('h2', 'revision-term', article.querySelector('.terms').textContent.trim());
    term.title = term.textContent; heading.appendChild(term);
    header.appendChild(heading);
    var x = button('×', close, 'revision-close'); x.setAttribute('aria-label', api.text('close'));
    header.appendChild(x); dialog.appendChild(header);
    var nav = state.nav = el('div', 'revision-navigation');
    state.older = button('←', function () {
      if (state.index + 1 < state.items.length) { state.index++; showRevision(state); }
      else if (state.next) load(state, true);
    });
    state.older.setAttribute('aria-label', api.text('older')); state.older.title = api.text('older');
    state.newer = button('→', function () { state.index--; showRevision(state); });
    state.newer.setAttribute('aria-label', api.text('newer')); state.newer.title = api.text('newer');
    state.select = el('select'); state.select.setAttribute('aria-label', api.text('select'));
    state.select.addEventListener('change', function () { state.index = Number(state.select.value); showRevision(state); });
    nav.append(state.older, state.select, state.newer); dialog.appendChild(nav);
    state.meta = el('p', 'revision-meta'); dialog.appendChild(state.meta);
    state.status = el('p', 'revision-status'); state.status.setAttribute('role', 'status');
    dialog.appendChild(state.status);
    state.retry = button(api.text('retry'), function () {
      if (state.retryEarlier) load(state, true);
      else if (state.items.length) showRevision(state); else load(state, false);
    }, 'revision-retry'); state.retry.hidden = true; dialog.appendChild(state.retry);
    state.content = el('div', 'revision-content'); state.content.hidden = true;
    var tablist = el('div', 'revision-tabs'); tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-label', api.text('title'));
    ['before', 'after'].forEach(function (name) {
      var tab = state[name + 'Tab'] = button(api.text(name), function () { tabs(state, name); });
      tab.id = 'revision-tab-' + name; tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', 'revision-pane-' + name);
      tab.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); var side = name === 'before' ? 'after' : 'before';
          tabs(state, side); state[side + 'Tab'].focus();
          // Mobile WebKit may retain touch modality with a hardware keyboard.
          state[side + 'Tab'].classList.add('is-keyboard-focus');
        }
      });
      tab.addEventListener('blur', function () { tab.classList.remove('is-keyboard-focus'); });
      tab.addEventListener('pointerdown', function () { tab.classList.remove('is-keyboard-focus'); });
      tablist.appendChild(tab);
    });
    state.content.appendChild(tablist);
    var legend = el('p', 'revision-legend');
    legend.append(el('del', 'diff-del', api.text('removed')), document.createTextNode(' · '),
      el('ins', 'diff-ins', api.text('added'))); state.content.appendChild(legend);
    state.notice = el('p', 'revision-notice'); state.content.appendChild(state.notice);
    var panes = el('div', 'revision-panes');
    ['before', 'after'].forEach(function (name) {
      var pane = state[name + 'Pane'] = el('section', 'revision-pane');
      pane.id = 'revision-pane-' + name; pane.setAttribute('aria-label', api.text(name));
      pane.tabIndex = 0; pane.appendChild(el('h3', '', api.text(name)));
      state[name + 'Body'] = el('div', 'revision-article descr'); pane.appendChild(state[name + 'Body']);
      // Historical references are read-only text, not a new search in the
      // underlying result page. Preserve selection and normal external links.
      ['mousedown', 'mouseup', 'click', 'dblclick'].forEach(function (type) {
        pane.addEventListener(type, function (event) { event.stopPropagation(); });
      });
      panes.appendChild(pane);
    });
    state.content.appendChild(panes); dialog.appendChild(state.content);
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    document.body.appendChild(dialog); document.body.classList.add('revision-history-open');
    dialog.showModal(); x.focus(); load(state, false);
    requestAnimationFrame(function () { if (term.scrollHeight > term.clientHeight) term.tabIndex = 0; });
  };
  window.addEventListener('resize', function () { if (current) tabs(current, current.side); });
})();
